import React from "react";
import ReactHtmlParser from 'react-html-parser';
import  SocialLink from './../SocialLink';

export default function Footer(props) {

  const { data }=props;

  return (
    <div className="row footer center" style={{backgroundColor:'#'+props.custom_design.colors[2].color}}>
        <div className="col m6">
          { ReactHtmlParser(data.phone) }
          { ReactHtmlParser(data.address) }
          { ReactHtmlParser(data.township) }
        </div>
        <div className="col m6">
          <h5>御相談の窓口</h5>
          <div className="button_container">
              <a href="/contactus" class="btn darken-3 " style={{backgroundColor:'#'+props.custom_design.colors[2].color}}>無料見積もり依頼</a>
              <a href="/contactus" class="btn darken-3 " style={{backgroundColor:'#'+props.custom_design.colors[2].color}}>お問い合わせ</a>
          </div>
        </div>
        <div class="col m12">
          <SocialLink  custom_design={props.custom_design} />
        </div>
    </div>
  );
}
